<template>
  <div :class="[{'disabled' : isDisabled}]" :title="label" class="bep-options-tab" @click="handleClick()">
    <span>{{ label }}</span>
    <i :class="useAddButton ? 'ddi-plus' : 'ddi-caret-down'" class="ddi" />
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'BepOptionsTab',

  props: {
    label: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    useAddButton: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['clicked'],

  data() {
    return {
      // TO DO
    }
  },

  computed: {},

  methods: {
    handleClick() {
      if (!this.isDisabled) {
        this.$emit('clicked')
      }
    },
  },
})
</script>

<style lang="scss">
.bep-options-tab {
  display: flex;
  align-items: center;
  @include flex-row-horizontal-spacing(4px);
  @include lettering--p-sm--no-color;
  font-weight: $bold;
  color: var(--color-text-primary);
  border: $border--dotted-dark;
  border-radius: 20px;
  padding: 2px 8px;
  cursor: pointer;
  max-width: 130px;

  span {
    @include single-line-ellipsis;
  }

  .ddi {
    color: var(--color-text-secondary);
  }

  .ddi-caret-down {
    font-size: 10px;
  }

  .ddi-plus {
    font-size: 9px;
    top: -1px;
  }

  &:hover {
    background-color: var(--color-background-primary);
  }

  &.disabled {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
